import { createModalFocusScope } from '../../components/modal-focus-scope.js';

/**
 * Puts the shared confirmation modal in front of the ranking delete form.
 *
 * The confirm button submits that form natively through its `form` attribute, so JS owns the
 * confirmation step and never the transport: with the modal open a submit is the confirmed one, with it
 * closed it is the trigger and gets intercepted. Without JS the modal stays hidden and the trigger
 * deletes directly, exactly as the manual list does.
 */
export function initRankingDeleteConfirm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-rankings-delete-form]');
    const modal = documentRef?.querySelector?.('[data-rankings-delete-modal]');
    const dialog = modal instanceof HTMLElement ? modal.querySelector('[data-rankings-delete-dialog]') : null;

    if (!(form instanceof HTMLFormElement) || !(modal instanceof HTMLElement) || !(dialog instanceof HTMLElement)) {
        return;
    }

    const trigger = form.querySelector('[data-rankings-delete-trigger]');

    const closeModal = () => {
        if (modal.hidden) {
            return;
        }

        modal.hidden = true;
        focusScope.deactivate();
    };

    const focusScope = createModalFocusScope({
        dialog,
        requestClose: closeModal,
        documentRef,
    });
    if (focusScope === null) {
        return;
    }

    form.addEventListener('submit', (event) => {
        if (!modal.hidden) {
            return;
        }

        event.preventDefault();
        modal.hidden = false;
        focusScope.activate(trigger);
        focusScope.focus();
    });

    modal.querySelectorAll('[data-rankings-delete-close]').forEach((button) => {
        button.addEventListener('click', () => closeModal());
    });
}
